import {updateTariff} from "@/api/tariff";
import {mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters('currentUserModule', ['isMainPartner']),
    },
    methods: {
        updateTariff(item) {
            updateTariff(item.id, item).then(() => {
                this.$message.success('Тариф змінений')
            }).catch(error => {
                this.$message.error(error.response.data.message)
            })
        },
    }
}
